import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/icon_button.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import spring from 'react-motion/lib/spring';
import Icon from 'soapbox/components/icon';
import emojify from 'soapbox/features/emoji/emoji';
import Motion from '../features/ui/util/optional_motion';
export default class IconButton extends React.PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "handleClick", e => {
      e.preventDefault();
      if (!this.props.disabled) {
        this.props.onClick(e);
      }
    });
    _defineProperty(this, "handleMouseDown", e => {
      if (!this.props.disabled && this.props.onMouseDown) {
        this.props.onMouseDown(e);
      }
    });
    _defineProperty(this, "handleKeyDown", e => {
      if (!this.props.disabled && this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }
    });
    _defineProperty(this, "handleKeyUp", e => {
      if (!this.props.disabled && this.props.onKeyUp) {
        this.props.onKeyUp(e);
      }
    });
    _defineProperty(this, "handleKeyPress", e => {
      if (this.props.onKeyPress && !this.props.disabled) {
        this.props.onKeyPress(e);
      }
    });
  }
  render() {
    const style = _objectSpread(_objectSpread({
      fontSize: `${this.props.size}px`,
      width: `${this.props.size * 1.28571429}px`,
      height: `${this.props.size * 1.28571429}px`,
      lineHeight: `${this.props.size}px`
    }, this.props.style), this.props.active ? this.props.activeStyle : {});
    const {
      active,
      animate,
      className,
      iconClassName,
      disabled,
      expanded,
      icon,
      src,
      inverted,
      overlay,
      pressed,
      tabIndex,
      title,
      text,
      emoji,
      type
    } = this.props;
    const classes = classNames(className, 'icon-button', {
      active,
      disabled,
      inverted,
      overlayed: overlay
    });
    if (!animate) {
      // Perf optimization: avoid unnecessary <Motion> components unless
      // we actually need to animate.
      return /*#__PURE__*/React.createElement("button", {
        "aria-label": title,
        "aria-pressed": pressed,
        "aria-expanded": expanded,
        title: title,
        className: classes,
        onClick: this.handleClick,
        onMouseDown: this.handleMouseDown,
        onKeyDown: this.handleKeyDown,
        onKeyUp: this.handleKeyUp,
        onKeyPress: this.handleKeyPress,
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        tabIndex: tabIndex,
        disabled: disabled,
        type: type,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 129,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: src ? {} : style,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 146,
          columnNumber: 11
        }
      }, emoji ? /*#__PURE__*/React.createElement("div", {
        className: "icon-button__emoji",
        dangerouslySetInnerHTML: {
          __html: emojify(emoji)
        },
        "aria-hidden": "true",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 148,
          columnNumber: 17
        }
      }) : /*#__PURE__*/React.createElement(Icon, {
        className: iconClassName,
        id: icon,
        src: src,
        fixedWidth: true,
        "aria-hidden": "true",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 149,
          columnNumber: 17
        }
      })), text && /*#__PURE__*/React.createElement("span", {
        className: "icon-button__text",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 151,
          columnNumber: 20
        }
      }, text));
    }
    return /*#__PURE__*/React.createElement(Motion, {
      defaultStyle: {
        rotate: active ? -360 : 0
      },
      style: {
        rotate: animate ? spring(active ? -360 : 0, {
          stiffness: 120,
          damping: 7
        }) : 0
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 157,
        columnNumber: 7
      }
    }, ({
      rotate
    }) => /*#__PURE__*/React.createElement("button", {
      "aria-label": title,
      "aria-pressed": pressed,
      "aria-expanded": expanded,
      title: title,
      className: classes,
      onClick: this.handleClick,
      onMouseDown: this.handleMouseDown,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      onKeyPress: this.handleKeyPress,
      onMouseEnter: this.props.onMouseEnter,
      onMouseLeave: this.props.onMouseLeave,
      tabIndex: tabIndex,
      disabled: disabled,
      type: type,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 159,
        columnNumber: 11
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: src ? {} : style,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 176,
        columnNumber: 13
      }
    }, emoji ? /*#__PURE__*/React.createElement("div", {
      className: "icon-button__emoji",
      style: {
        transform: `rotate(${rotate}deg)`
      },
      dangerouslySetInnerHTML: {
        __html: emojify(emoji)
      },
      "aria-hidden": "true",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 178,
        columnNumber: 19
      }
    }) : /*#__PURE__*/React.createElement(Icon, {
      className: iconClassName,
      id: icon,
      src: src,
      style: {
        transform: `rotate(${rotate}deg)`
      },
      fixedWidth: true,
      "aria-hidden": "true",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 179,
        columnNumber: 19
      }
    })), text && /*#__PURE__*/React.createElement("span", {
      className: "icon-button__text",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 181,
        columnNumber: 22
      }
    }, text)));
  }
}
_defineProperty(IconButton, "propTypes", {
  className: PropTypes.string,
  iconClassName: PropTypes.string,
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  src: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyPress: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  size: PropTypes.number,
  active: PropTypes.bool,
  pressed: PropTypes.bool,
  expanded: PropTypes.bool,
  style: PropTypes.object,
  activeStyle: PropTypes.object,
  disabled: PropTypes.bool,
  inverted: PropTypes.bool,
  animate: PropTypes.bool,
  overlay: PropTypes.bool,
  tabIndex: PropTypes.string,
  text: PropTypes.string,
  emoji: PropTypes.string,
  type: PropTypes.string
});
_defineProperty(IconButton, "defaultProps", {
  size: 18,
  active: false,
  disabled: false,
  animate: false,
  overlay: false,
  tabIndex: '0',
  onKeyUp: () => {},
  onKeyDown: () => {},
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  type: 'button'
});